<script lang="ts">
    export let ariaSelected: boolean;
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-to-interactive-role -->
<li
    class="gw-select-item"
    on:keydown
    role="option"
    aria-selected={ariaSelected}
>
    <button class="gw-select-item__btn gw-focus-reset" on:click>
        <slot />
    </button>
</li>

<style>
    .gw-select-item__btn {
        display: block;
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0.5em 0.4em;
        border: 0px solid transparent;
        border-radius: var(--gw-border-radius-sm);
        background: none;
        color: inherit;
        color: var(--gw-dark-text-color);
        font-size: 0.9em;
        text-align: left;
        text-decoration: none;
        white-space: nowrap;
        cursor: pointer;
        appearance: none;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .gw-select-item:hover .gw-select-item__btn {
        background: var(--gw-lightgrey-bg);
    }
</style>
